import styled from 'styled-components/macro'

const FilterText = styled.span`
  display: block;
  padding-right: 12px;
`

export default FilterText
